module.exports = "/images/multiline-icon.svg?9700eb4efdceb9770894eb13a76855c0";